import React, {Component} from 'react';
import './FormFieldList.css';

class FormFieldList extends Component {
	render() {
		return (
			<ol className="FormFieldList">
				{this.props.children}
			</ol>
		);
	}
}

export default FormFieldList;


// WEBPACK FOOTER //
// ./src/widgets/FormFieldList.js